module.exports = __webpack_public_path__ + "img/boaz-back.6387d301.webp";